import { Guid } from "guid-typescript";
import { Resource } from "src/app/interfaces/Index";
import { environment } from "src/environments/environment";
import { FetchInterceptor } from "../helpers/Index";
import { Service } from "./Service";

const endpoint = "Resource";
export const ResourceService = {
	endpoint,
	createSingle: async (data: Resource) => await Service.createSingle(endpoint, data),
	deleteSingleById: async (id: number) => await Service.deleteSingleById(endpoint, id),
	getAll: async () => await Service.getAll(endpoint),
	getGeneral: async () => await FetchInterceptor(`${environment.server.apiURL}/${endpoint}/GetGeneral`, {headers: {"Content-Type": "application/json"}, method: "GET"}),
	getSingleById: async (id: number) => await Service.getSingleById(endpoint, id),
	getSingleByLookupId: async (id: Guid) => await Service.getSingleByLookupId(endpoint, id),
	updateSingleById: async (id: number, data: Resource) => await Service.updateSingleById(endpoint, id, data),
}